const LOGIN = "/login";
const ROOT = "/";
const USERS = "/users";
const USERS_CREATE = `${USERS}/create`;
const USERS_EDIT = `${USERS}/edit`;
const USERS_CREATE_ADMIN = `${USERS}/create-admin`;
const USERS_EDIT_ADMIN = `${USERS}/edit-admin`;
const DASHBOARD = "/dashboard";
const CONSENTS = "/consents";
const APPS = "/apps";
const CONSENTS_CONSENT_ELEMENTS = `${CONSENTS}/consent-elements`;
const CONSENT_ELEMENT_CREATE = `${CONSENTS_CONSENT_ELEMENTS}/create`;
const CONSENT_ELEMENT_EDIT = `${CONSENTS_CONSENT_ELEMENTS}/edit`;
const MARKETS = "/markets";
const CREATE_APP = `${APPS}/create`;
const NOTIFICATIONS = "/notifications";
const NOTIFICATIONS_CREATE = `${NOTIFICATIONS}/create`;
const NOTIFICATIONS_EDIT = `${NOTIFICATIONS}/edit`;
const FLEET_MANAGEMENT = "/fleet-management";
const FW_VERSION_CREATE = `${FLEET_MANAGEMENT}/fw-version/create`;
const FW_VERSION_EDIT = `${FLEET_MANAGEMENT}/fw-version/edit`;
const HARDWARE = `/hardware`;
const USER_INSIGHTS = "/user-insights";

const routePaths = {
  LOGIN,
  ROOT,
  USERS,
  USERS_CREATE,
  USERS_EDIT,
  USERS_CREATE_ADMIN,
  USERS_EDIT_ADMIN,
  DASHBOARD,
  CONSENTS,
  CONSENTS_CONSENT_ELEMENTS,
  CONSENT_ELEMENT_CREATE,
  CONSENT_ELEMENT_EDIT,
  MARKETS,
  APPS,
  CREATE_APP,
  NOTIFICATIONS,
  NOTIFICATIONS_CREATE,
  NOTIFICATIONS_EDIT,
  FLEET_MANAGEMENT,
  FW_VERSION_CREATE,
  FW_VERSION_EDIT,
  HARDWARE,
  USER_INSIGHTS
};

export default routePaths;
